import { render, staticRenderFns } from "./DownloadHomeTwo.vue?vue&type=template&id=fe579632&"
import script from "./DownloadHomeTwo.vue?vue&type=script&lang=js&"
export * from "./DownloadHomeTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports